import React, {useState, useEffect, useRef} from 'react';
import Modal from 'react-bootstrap/Modal';
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import '../../global/components/scroll-bar.css';
import { parseMarginPadding } from '../../utils/controlUtils';
import { displayTopicCompUtil, entryPoint } from '../../utils/topicUtils';
import PresentationEditor from './PresentationEditor';
import PresentationContPageItem from './PresentationContPageItem';

const PresentationContPage = ({topic, obj, edit}) => {

  const [position, setPosition] = useState(-1);
  const [modal, setModal] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const itemRefs = useRef([]);
    
  const isMobile = width <= 768;
  const mode = edit? 'edit': 'preview';

  const content = JSON.parse(obj.Content);
  const presentation = obj.Presentation;
  const title = content.Title;
  const display = content.Display;
  const desc = content.Description;
  const align = content.Align;
  const theme = content.Theme;
  const size = content.Size;
  const spacing = content.ItemSpacing;
  const marginPadding = content.MarginPadding;
    
  const mp = parseMarginPadding(marginPadding);
    
  const colors = theme.split("-");
  const bgColor = colors[0];
  const txtColor = colors[1];
  const extra1 = colors[2];
  const extra2 = colors[3];
  const extra3 = colors[4];

  let titleSz = 0; let textSz = 0; let zoom = 0;
  if(size == "small"){ titleSz=20; textSz=14 }
  else if(size == "medium"){ titleSz=24; textSz=18 }
  else if(size == "large"){ titleSz=38; textSz=24 }
    
  let space = 0;
  if(spacing == "small"){ space = 20; }
  else if(spacing == "medium"){ space = 30; }
  else if(spacing == "large"){ space = 40; }

  if(presentation != ""){
    const ptn = JSON.parse(presentation);
    if(ptn.TitleSize != "") { titleSz = parseInt(ptn.TitleSize) }
    if(ptn.TextSize != "") { textSz = parseInt(ptn.TextSize) }
    if(ptn.Zoom != "") { zoom = parseInt(ptn.Zoom) }
  }

  useEffect(()=>{
    const handleKeyDown = (event) => {
      switch (event.key) {
        case "ArrowUp":
          gotoNext();
          break;
        case "ArrowRight":
          gotoNext();
          break;
        case "ArrowDown":
          gotoPrev();
          break;
        case "ArrowLeft":
          gotoPrev()
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => { window.removeEventListener("keydown", handleKeyDown) };
  }, [position]);

  function gotoNext(){
    if(position < (obj.Sub.length - 1)){
      setPosition(position + 1);
    }else{
      if(obj.Next != 'end'){
        window.location = `/topic/presentation/${topic.Slug}/${obj.Next}?mode=${mode}`;
      }
    }
  }

  function gotoPrev(){
    if(position == -1){
      setPosition(obj.Sub.length);
    }else{
      if(obj.Prev == 'start'){
        window.location = `/topic/presentation-start/${topic.Slug}`;
      }else{
        window.location = `/topic/presentation/${topic.Slug}/${obj.Prev}?mode=${mode}`;
      }
    }
  }

  const showModal = ()=>{
    setModal(true);
  }

  const closeModal = ()=>{
    setModal(false);
  }

  const styles = {
    container:{
      background: bgColor,
      minHeight: 200,
      zoom: `${zoom}%`,
      position: 'relative',
      marginTop: mp.marginTop,
      marginRight: mp.marginRight,
      marginBottom: mp.marginBottom,
      marginLeft: mp.marginLeft,
      paddingTop: mp.paddingTop,
      paddingRight: mp.paddingRight,
      paddingBottom: mp.paddingBottom,
      paddingLeft: mp.paddingLeft,
    },
    editBtn:{
      background: '#fff',
      color: '#666',
      width: 23,
      height: 23,
      fontSize: 11,
      padding: 3,
      border: '1px solid #ccc',
      textAlign: 'center',
      borderRadius: '100%',
      position: 'absolute',
      top: 0,
      right: 0,
      zIndex: 999,
      outline: 'none',
      boxShadow: 'none',
      transition: 'none',
    },
    head:{
      marginBottom: 10
    },
    title:{
        color: txtColor,
        marginBottom: 5,
        fontSize: titleSz,
        textAlign: align,
        fontWeight: 600
    },
    desc:{
        color: txtColor,
        fontSize: textSz,
        textAlign: align
    },
    hr: {
        borderColor: extra3
    },
    body:{
      display: 'flex',
      flexDirection: display,
      alignItems: 'center',
      padding: isMobile? 10: 0,
      overflowX: isMobile? 'scroll': 'visible'
    },
    item:{
      flex: 1,
      marginRight: space,
      position: 'relative'
    },
  }
  
  const itemParams = {
    container: obj,
    position: position,
    edit: edit
  }

  return(
    <div style={styles.container}>

      {edit && 
        <button onClick={showModal} style = {styles.editBtn}> 
          <FontAwesomeIcon icon={faCog} />
        </button>
      } 

      {(title != "" || desc != "") &&
        <div style={styles.head}>
          <>
            {(title != "") && <h2 style={styles.title}>{title}</h2>}
            {(desc != "") && <div style={styles.desc}>{desc}</div>}
            <hr style={styles.hr} />
          </>
        </div>
      }   

      <div style={styles.body} className='hide-scroll-bar'>
        {obj.Sub.map((itm, i) => (
          <div ref={itemRefs.current[i]} style={styles.item}>
            <PresentationContPageItem key={i} obj={itm} index={i} params={itemParams} />
          </div>
        ))}
      </div>

      <Modal size='md' show={modal} onHide={closeModal} backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title style={{fontSize:15}}>Editor</Modal.Title>
          <button type="button" onClick={closeModal} className="close">&times;</button>
        </Modal.Header>
        <Modal.Body> 
          <PresentationEditor obj={obj} close={closeModal} />
        </Modal.Body> 
      </Modal>

    </div>
  )
    
}

export default PresentationContPage;